import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { pathOr } from 'ramda';
import { Input } from 'antd';
import DropdownSelect from 'components/DropdownSelect';
import { useCarePlanDraftStore, selectDrafts } from 'stores/carePlanDraft';
import { DetailsLabel, DraftFieldsWrapper, DropdownFieldWrapper } from './styled';
var IN_NETWORK_OPTIONS = [
    {
        key: 'in_network',
        label: 'In Network'
    },
    {
        key: 'out_of_network',
        label: 'Out of Network'
    }
];
var PATIENT_STATUS = [
    {
        key: 'accepting_new',
        label: 'Accepting New Patients'
    },
    {
        key: 'not_accepting_new',
        label: 'Not Accepting New Patients'
    }
];
export var DraftFields = function (_a) {
    var draftId = _a.draftId, entityId = _a.entityId;
    var _b = useCarePlanDraftStore(selectDrafts), drafts = _b.drafts, updateDraft = _b.updateDraft;
    var inNetworkStatus = pathOr('', [draftId, entityId, 'form_data', 'in_network'], drafts);
    var patientsStatus = pathOr('', [draftId, entityId, 'form_data', 'accepting_new_patients'], drafts);
    var draftNote = pathOr('', [draftId, entityId, 'form_data', 'draft_note'], drafts);
    var updateDraftNote = function (e) {
        var _a;
        var note = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || '';
        updateDraft(draftId, entityId, { form_data: { draft_note: note } });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(DraftFieldsWrapper, { children: [_jsxs(DropdownFieldWrapper, { children: [_jsx(DetailsLabel, { children: "In Network Status" }), _jsx(DropdownSelect, { value: inNetworkStatus, options: IN_NETWORK_OPTIONS, onClick: function (menuItem) { return updateDraft(draftId, entityId, { form_data: { in_network: menuItem === null || menuItem === void 0 ? void 0 : menuItem.key } }); } })] }), _jsxs(DropdownFieldWrapper, { children: [_jsx(DetailsLabel, { children: "Patient Status" }), _jsx(DropdownSelect, { value: patientsStatus, options: PATIENT_STATUS, onClick: function (menuItem) { return updateDraft(draftId, entityId, { form_data: { accepting_new_patients: menuItem === null || menuItem === void 0 ? void 0 : menuItem.key } }); } })] })] }), _jsx(Input, { placeholder: "New Draft Note", value: draftNote, onChange: updateDraftNote })] }));
};
